const o = "action";
export {
  o as MENU_ACTION_TYPE
};
